<template>
  <h4>ContractDashboard.vue</h4>
</template>

<script>
export default {
  data() {},
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
